import { SectionItem } from './Menu';

const menuList: SectionItem[] = [
    { id: 0, sectionName: 'Other Projects', link: '/other' },
    { id: 1, sectionName: 'Resume', link: '/resume' },
    { id: 2, sectionName: 'LinkedIn', link: 'https://www.linkedin.com/in/castrogabriel/' },
    { id: 3, sectionName: 'Contact', link: '/contact' }
]

export default menuList